import { useEffect, useState } from "react";
import {
  AccordionDetails,
  AccordionSummary,
  Accordion as AccordionComponent,
} from "@mui/material";
import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";

const Accordion = ({
  title,
  children,
  isBordered = true,
  hasPersistentDivider = false,
  isDefaultExpanded = false,
}) => {
  const [isOpen, setIsOpen] = useState(isDefaultExpanded);

  useEffect(() => {
    setIsOpen(isDefaultExpanded);
  }, [isDefaultExpanded]);

  return (
    <AccordionComponent
      defaultExpanded={isDefaultExpanded}
      expanded={isOpen}
      style={{
        ...(!hasPersistentDivider && {
          border: isBordered ? "1px solid #E5E5E5" : "none",
        }),
        boxShadow: isBordered ? "0px 0px 4px rgba(0, 0, 0, 0.25)" : "none",
      }}
      sx={
        hasPersistentDivider
          ? {
              border: "none",
              "&::before": { display: "none" },
              "&:not(:first-of-type)": { borderTop: "1px solid #E0E0E0" },
            }
          : undefined
      }
      onChange={(_e, expanded) => setIsOpen(expanded)}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
        style={{ padding: "0" }}
      >
        {title}
      </AccordionSummary>
      {isOpen && (
        <AccordionDetails style={{ padding: "0" }}>{children}</AccordionDetails>
      )}
    </AccordionComponent>
  );
};

export default Accordion;
